import { Injectable, inject } from "@angular/core";
import { Observable, map, of } from "rxjs";
import { Box } from "../../models/box";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { UserNotify } from "src/app/support/notify-decorator";
import { rxRandomErrorDelayAsync } from "src/app/support/rx-random-error-delay";
import { Archive } from "src/app/modules/bootstrap/rocket-ui/backend/models/archive";
import { PaginatedResult } from "src/app/support/paginated-result";

@Injectable()
export class BoxBackend {
  private readonly http = inject(HttpClient);

  load(): Observable<PaginatedResult<Box>> {
    return this.http.get<PaginatedResult<Box>>(
      `${environment.snoots.api.diagnostic}/boxes`,
      {
        headers: {
          "snt-product": "rocket"
        }
      }
    );
  }

  listAll(): Observable<Box[]> {
    return this.load().pipe(map((response) => response.docs));
  }

  loadByTenant(tenantId: string): Observable<PaginatedResult<Box>> {
    return this.http.get<PaginatedResult<Box>>(
      `${environment.snoots.api.diagnostic}/boxes?tenantId=${tenantId}`
    );
  }

  listArchive(): Observable<any[]> {
    return of([]);
  }

  listAlarms(id: string): Observable<any[]> {
    return of([]);
  }

  loadArchiveById(id: string): Observable<Archive> {
    return rxRandomErrorDelayAsync(Promise.resolve({} as Archive));
  }

  loadBoxs(): Observable<Box[]> {
    throw new Error("Method not implemented.");
  }

  listSpaceUsed(archive: string): Observable<any[]> {
    return of([]);
  }

  list(): Observable<Box[]> {
    return of([]);
  }

  create({
    tenant,
    account
  }: {
    tenant: string;
    account: string;
  }): Observable<Box> {
    return this.http.post<Box>(`${environment.snoots.api.diagnostic}/boxes`, {
      sharing: "never",
      tenant,
      account
    });
  }

  @UserNotify({
    successMessage: marker("Box aggiornato"),
    errorMessage: marker("Non è stato possibile aggiornare il box")
  })
  update(id: string, data: { sharing: string }): Observable<Box> {
    return this.http.patch<Box>(
      `${environment.snoots.api.diagnostic}/boxes/${id}`,
      {
        sharing: data.sharing
      }
    );
  }
}
